import styled from "styled-components";
import { space, color } from "styled-system";

export const Component = styled.div`
  ${space}
  ${color}
`;
